import { render } from "./FeesInformation.vue?vue&type=template&id=78965ba3"
import script from "./FeesInformation.vue?vue&type=script&lang=js"
export * from "./FeesInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__